import axios from "axios";
import { store } from "../Modules/Presentation/store";
import { refreshTokenThunk } from "../Modules/User/Presentation/actions";
import { logout } from "../Modules/User/Presentation/reducers";
import {
  getSlotOpsOverrideToken,
  shouldAttachSlotOpsOverrideHeader,
} from "../Utils/slotOpsOverride";

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://re-stizen.xyz/",
  headers: { "Content-Type": "application/json" },
});

/* 요청마다 access 넣기 */
api.interceptors.request.use((cfg) => {
  const s = store.getState() as any;
  const acc = s?.auth?.access ?? localStorage.getItem("access");
  if (acc) cfg.headers.Authorization = `Bearer ${acc}`;

  const overrideToken = getSlotOpsOverrideToken();
  const requestUrl = cfg.url ?? "";
  if (overrideToken && shouldAttachSlotOpsOverrideHeader(requestUrl)) {
    cfg.headers["X-Slot-Ops-Override"] = overrideToken;
  }

  return cfg;
});

/* 401 처리 → refresh → 재시도 (동시 요청 큐 처리) */
let refreshPromise: Promise<any> | null = null;
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const { response, config } = err;
    if (response?.status === 401 && !config._retry) {
      config._retry = true;
      if (!refreshPromise) {
        refreshPromise = store
          .dispatch(refreshTokenThunk())
          .unwrap()
          .finally(() => {
            refreshPromise = null;
          });
      }
      try {
        await refreshPromise;
        return api(config); // 요청 인터셉터가 최신 access를 주입
      } catch (e) {
        store.dispatch(logout());
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  },
);
